'use strict';

function CompanyGuestNotesCtrl() {
}

angular.module('dokiv')
  .controller('CompanyGuestNotesCtrl', [CompanyGuestNotesCtrl]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company-guest/notes/CompanyGuestNotesCtrl.js
// module id = 294
// module chunks = 0